import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
  },
  noteText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.text.primary,
    width: 'fit-content',
  },
  field: {
    width: theme.spacing(53.5),
    marginTop: theme.spacing(2),
  },
  note: {
    width: 'fit-content',
    maxWidth: '933px',
  },
}))
